import json from './serviceList.json';

// Mapping a generated unique, human-readable SERVICE_PATH to its query string.
// remove comments and make it typed.
const serviceList = Object.fromEntries(
  Object.entries(json).filter(([key]) => !key.startsWith('_'))
) as { [key: string]: string };

export default serviceList;
